import React from 'react';
import { Input, Button } from 'components';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { WhiteImage } from 'assets/img';
import { Constants, Globals } from 'utils';
import { UserService, LawyerService, StorageService } from 'services';
import { EditIcon, DownloadIcon, Document2Icon, StarActiveIcon } from 'assets/icons';
import moment from 'moment';

interface Props {
  onClose?: any;
  item?: any;
  edit?: any;
  reload?: any;
}

class ModalView extends React.Component<Props> {
  state = {
    user: this.props.item,
    average: 0,
    loadingDoc: {
      inpre: false,
      identity_document: false,
      title: false,
      speciality: false,
    },
  };

  componentDidMount() {
    this.load();
  }

  load = async () => {
    const res: any = await UserService.admin.view({
      user_id: this.props.item?.id,
    });
    this.setState({
      user: res.user,
      average: res.average || 0,
    });
  };

  openDocument = async (key: string, field: string) => {
    this.setState({
      loadingDoc: { ...this.state.loadingDoc, [field]: true },
    });
    try {
      const url = await StorageService.getSignedUrl(key);
      if (url) {
        window.open(url, '_blank');
      } else {
        Globals.showError('No se pudo obtener el documento');
      }
    } catch (e) {
      Globals.showError('Error al obtener el documento');
    } finally {
      this.setState({
        loadingDoc: { ...this.state.loadingDoc, [field]: false },
      });
    }
  };

  changeStatus = (item: any, action: number) => {
    let message = '';
    let message_confirm = '';

    switch (action) {
      case Constants.VERIFIED.VERIFIED:
        message = '¿Desea verificar el abogado?';
        message_confirm = 'Se ha verificado el abogado';
        break;
      case Constants.VERIFIED.REJECTED:
        message = '¿Desea rechazar el abogado?';
        message_confirm = 'Se ha rechazado el abogado';
        break;
    }

    Globals.confirm(message, async () => {
      await LawyerService.admin.changeStatus({ lawyer_id: item?.id, action });
      this.load();
      this.props.reload();
      Globals.showSuccess(message_confirm);
    });
  };

  render() {
    const user: any = this.state.user;
    const { average } = this.state;

    return (
      <div id='modal-view-user'>
        <div className='container-user'>
          <img src={user.photo ? Constants.BASE_STORAGE + user.photo : WhiteImage} />
          <div className='container-text'>
            <p className='title'>Nombre</p>
            <p className='name'>{user?.full_name}</p>
          </div>
        </div>
        <div className='padding'>
          <a
            href='#'
            className='btn-edit'
            onClick={(e: any) => {
              e.preventDefault();
              this.props.edit();
            }}
          >
            <p>
              <img src={EditIcon} /> Editar
            </p>
          </a>
          {(user?.level_id == Constants.LEVELS.CLIENT ||
            user?.level_id == Constants.LEVELS.MODERATOR) && (
            <div className='container-data'>
              <p>
                <strong>Fecha de registro:</strong> {moment(user?.created_at).format('DD/MM/YYYY')}
              </p>
              <p>
                <strong>C.I.:</strong> {user?.full_document}
              </p>
              <p>
                <strong>Teléfono:</strong> {user?.full_phone}
              </p>
              <p>
                <strong>Correo:</strong> {user?.email}
              </p>
            </div>
          )}
          {user?.level_id == Constants.LEVELS.LAWYER && (
            <div className='container-data'>
              <div className='row'>
                <div className='col-md-6'>
                  <p>
                    <strong>Fecha de registro:</strong>{' '}
                    {moment(user?.created_at).format('DD/MM/YYYY')}
                  </p>
                  <p>
                    <strong>Nº de Inpre:</strong> {user?.lawyer_document || '-'}
                  </p>
                  <p>
                    <strong>C.I.:</strong> {user?.full_document}
                  </p>
                  <p>
                    <strong>Teléfono:</strong> {user?.full_phone}
                  </p>
                </div>
                <div className='col-md-6'>
                  <p>
                    <strong>Correo:</strong> {user?.email}
                  </p>
                  <p style={{ display: 'flex' }}>
                    <strong>Ranking:</strong>
                    <div className='container-rating'>
                      {average >= 1 && <img src={StarActiveIcon} />}
                      {average >= 2 && <img src={StarActiveIcon} />}
                      {average >= 3 && <img src={StarActiveIcon} />}
                      {average >= 4 && <img src={StarActiveIcon} />}
                      {average >= 5 && <img src={StarActiveIcon} />}
                    </div>
                    {!average && <>-</>}
                  </p>
                  <p>
                    <strong>Equipo:</strong>{' '}
                    {user?.internal == Constants.LAWYER_INTERNAL.YES ? 'Interno' : 'Externo'}
                  </p>
                </div>
                {user?.user_areas?.length > 0 && (
                  <div className='col-md-12'>
                    <p>
                      <strong>Tipo de derecho:</strong>{' '}
                      {user?.user_areas?.map((i: any) => i.area?.name).join(', ')}
                    </p>
                  </div>
                )}
                <div className='col-md-6'>
                  <p>
                    <strong>Inpre:</strong>
                  </p>
                  {user?.documents?.inpre ? (
                    <button
                      type='button'
                      className='download-file'
                      disabled={this.state.loadingDoc.inpre}
                      onClick={() => this.openDocument(user.documents.inpre, 'inpre')}
                    >
                      <img className='default-icon' src={Document2Icon} />
                      <p>Documento</p>
                      {this.state.loadingDoc.inpre ? (
                        <span className='doc-loader' />
                      ) : (
                        <img src={DownloadIcon} />
                      )}
                    </button>
                  ) : (
                    <p className='note-document'>El usuario no ha cargado la foto del inpre</p>
                  )}
                </div>
                <div className='col-md-6'>
                  <p>
                    <strong>Cédula de Identidad:</strong>
                  </p>
                  {user?.documents?.identity_document ? (
                    <button
                      type='button'
                      className='download-file'
                      disabled={this.state.loadingDoc.identity_document}
                      onClick={() =>
                        this.openDocument(user.documents.identity_document, 'identity_document')
                      }
                    >
                      <img className='default-icon' src={Document2Icon} />
                      <p>Documento</p>
                      {this.state.loadingDoc.identity_document ? (
                        <span className='doc-loader' />
                      ) : (
                        <img src={DownloadIcon} />
                      )}
                    </button>
                  ) : (
                    <p className='note-document'>
                      El usuario no ha cargado la foto de su documento de identidad
                    </p>
                  )}
                </div>
                <div className='col-md-6'>
                  <p>
                    <strong>Título:</strong>
                  </p>
                  {user?.documents?.title ? (
                    <button
                      type='button'
                      className='download-file'
                      disabled={this.state.loadingDoc.title}
                      onClick={() => this.openDocument(user.documents.title, 'title')}
                    >
                      <img className='default-icon' src={Document2Icon} />
                      <p>Documento</p>
                      {this.state.loadingDoc.title ? (
                        <span className='doc-loader' />
                      ) : (
                        <img src={DownloadIcon} />
                      )}
                    </button>
                  ) : (
                    <p className='note-document'>El usuario no ha cargado la foto del título</p>
                  )}
                </div>
                <div className='col-md-6'>
                  <p>
                    <strong>Especialidad:</strong>
                  </p>
                  {user?.documents?.speciality ? (
                    <button
                      type='button'
                      className='download-file'
                      disabled={this.state.loadingDoc.speciality}
                      onClick={() => this.openDocument(user.documents.speciality, 'speciality')}
                    >
                      <img className='default-icon' src={Document2Icon} />
                      <p>Documento</p>
                      {this.state.loadingDoc.speciality ? (
                        <span className='doc-loader' />
                      ) : (
                        <img src={DownloadIcon} />
                      )}
                    </button>
                  ) : (
                    <p className='note-document'>
                      El usuario no ha cargado la foto de la especialidad
                    </p>
                  )}
                </div>
                {(user?.verified == Constants.VERIFIED.PENDING ||
                  user?.verified == Constants.VERIFIED.IN_PROCESS) && (
                  <div className='col-md-12'>
                    <div className='row'>
                      <div className='col-md-6 text-right'>
                        <button
                          className='btn btn-success'
                          onClick={() => this.changeStatus(user, Constants.VERIFIED.VERIFIED)}
                        >
                          Aprobar
                        </button>
                      </div>
                      <div className='col-md-6'>
                        <button
                          className='btn btn-danger'
                          onClick={() => this.changeStatus(user, Constants.VERIFIED.REJECTED)}
                        >
                          Rechazar
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default ModalView;
